'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = CarTypeDescriptionPanel;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _emailStyleTools = require('helpers/emailStyleTools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CarTypeDescriptionPanel(props) {
  var type = props.type,
      components = props.components;

  var styleCompactManualContainer = (0, _emailStyleTools.containerStyles)(components, 'CompactManualContainer');
  var styleCompactManualLabel = (0, _emailStyleTools.textStyles)(components, 'CompactManualLabel');

  return _react2.default.createElement(
    'table',
    { style: _emailStyleTools.fullMinimal, 'data-component': 'CarTypeDescriptionPanel' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, styleCompactManualContainer, _emailStyleTools.padTen) },
          _react2.default.createElement(
            'span',
            { style: styleCompactManualLabel },
            type
          )
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Car/Email/Active/CarTypeDescriptionPanel.jsx
// module id = 1498
// module chunks = 0